<template lang="pug">
  .record-payment
    y-dialog(fill-height fluid v-model="showModal" scrollable :fullscreen="$vuetify.breakpoint.xsOnly" transition="fade-transition" persistent max-width="600px")
      v-card(min-height="80vh")
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic100}`")
          p.mb-0.h6.basic800--text Edit Payment
        v-divider.basic300
        
        v-card-text.px-0.pb-0
          v-form(ref="form")

            .payment-date.px-6.mt-6
              .label.basic600--text.text-uppercase Date
              v-dialog(v-model='form.date.show' width='290px')
                template(v-slot:activator='{ on }')
                  v-text-field.mt-2(:value="form.date.value" placeholder="Select date" outlined dense background-color="basic200" readonly v-on='on' :rules="rules.is_selected")
                    template(v-slot:append)
                      eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                v-date-picker(v-model='form.paymentDate' color="primary" no-title @change="saveDate()")
            
            .payment-method.px-6
              .label.basic600--text.text-uppercase Payment Method
              v-row.px-3.mb-n2.mt-2
                v-radio-group.mt-2(v-model='form.paymentMethod' row dense)
                  v-radio.mb-4(v-for="(method, index) in paymentMethods" :value="method.name" style="width:100%" :key="method.id")
                    template(v-slot:label)
                      div
                        .p1.textColorDefault--text {{ method.name }}
              
            .payment-amount.px-6
              .label.basic600--text.text-uppercase Amount paid
              v-text-field.mt-2(v-model='form.paymentAmount' :placeholder="$t('price.placeholder')" background-color="basic200" height="40" outlined dense type="number" :rules="priceRules" :prefix="$currency.symbol")
        
        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-medium.primary400--text Cancel
          v-btn.mr-2(color='info500' depressed @click="clickSave()" :loading="isLoading")
            .button-AA-medium.basic100--text {{ $t('save') }}
        

</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'EditPaymentDialog',
  props: ['open', 'parentPayment', 'parentIncome'],
  data: () => ({
    isFetching: false,
    form: { 
      paymentMethod: null,
      paymentDate: null,
      paymentAmount: 0,
      date: {
        show: false,
        value: null
      }
    },
    paymentMethods: [],
    isLoading: false,
    rules: {
      is_selected: [(v) => v !== null || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v > 0|| 'This field is required']
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    payment: {
      get() {
        return this.parentPayment
      },
      set(newValue) {
        this.$emit('payment-edited', newValue)
      }
    },
    income: {
      get() {
        return this.parentIncome
      },
      set(newValue) {
        this.$emit('update:parentIncome', newValue)
      }
    },
    priceRules () {
      return [
        v => !!v || 'Amount is required',
        v => v != 0|| 'Amount is required'
      ]
    }
  },
  mounted () {
    this.form.paymentMethod = this.payment.payment_method
    this.form.paymentDate = this.payment.date
    this.form.date.value = this.formatDate(this.form.paymentDate)
    this.getPaymentMethods()
    this.form.paymentAmount = this.payment.amount/this.$currency.multiplier
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    getPaymentMethods () {
      this.isFetching = true
      this.$axios.get(`/books/${this.company.slug}/payment_methods`).then((response) => {
        this.isFetching = false
        this.paymentMethods = response.data.results
      }).catch(() => {})
    },
    saveDate () {
      this.form.date.show = false
      this.form.date.value = this.formatDate(this.form.paymentDate)
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      const params = {
        date: this.form.paymentDate,
        payment_method: this.form.paymentMethod,
        amount: (parseFloat(this.form.paymentAmount)).toFixed(this.$currency.exponent).replace('.', '')
      }
      this.$axios.patch(`/books/${this.company.slug}/incomes/${this.income.pid}/payments/${this.payment.uid}`, params)
        .then(resp => {
          this.payment = resp.data
          this.$axios.get(`/books/${this.company.slug}/incomes/${this.income.pid}/?expand=category`)
            .then(resp => {
              this.income = resp.data
              this.showMessage(['success', this.$t('success_message.payment_edited')])
              this.showModal = false
            }).catch(() => {})
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white !important;
}
</style>

<i18n>
{
  "en": {
    "price": {
      "label": "Amount",
      "placeholder": "0"
    },
    "cancel": "Cancel",
    "save": "Save"
  }
}
</i18n>
